// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchInput_container__6CeAa","prefix":"SearchInput_prefix___oUnx","input":"SearchInput_input__3FEMg"};